import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import local i18n locales
import en from './locales/en.json';
import uk from './locales/uk.json';
import de from './locales/de.json';

/** Languages the admin console can be switched to. */
export const ADMIN_LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'uk', label: 'Українська' },
  { code: 'de', label: 'Deutsch' },
] as const;

const STORAGE_KEY = 'admin_lang';
const stored = typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null;
const initialLng = ADMIN_LANGUAGES.some((l) => l.code === stored) ? (stored as string) : 'en';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    uk: { translation: uk },
    de: { translation: de },
  },
  lng: initialLng,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  ns: ['translation'],
  defaultNS: 'translation',
});

// Persist the choice so it survives reloads.
i18n.on('languageChanged', (lng) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, lng);
  } catch {
    /* ignore storage errors */
  }
});

export default i18n;
